/**
 * EncryptedToken
 */
class EncryptedToken {
  readonly token: string;

  /**
   * Constructor
   *
   * @param token
   */
  constructor(token?: string) {
    this.token = token;
  }

  /**
   * ToString
   *
   * @returns {string}
   */
  public toString(): string {
    return this.token;
  }
}

export { EncryptedToken };
